import { createBaseAction } from '@essent/common';
import type { proposition_id as ProductSelection } from '@integration/api-client/emobility';
import { createAction, props } from '@ngrx/store';
import type { LinkField } from '@sitecore-jss/sitecore-jss-angular';

import type { CustomerType } from './lead-form-customer-details.reducer';

const PREFIX = '[Emobility Lead Form]';

export const initializeLeadForm = createBaseAction<{
  thankYouPageUrl?: LinkField;
  chargePointConfigurationEnabled: boolean;
  e2eTrackingId: string;
  callbackMomentEnabled: boolean;
  loginPromptEnabled: boolean;
  customerType: CustomerType;
  salutationEnabled: boolean;
}>(`${PREFIX} initialize`);

export const setEmobilityLeadFormType = createAction(
  `${PREFIX} set lead form type`,
  props<{ proposition: ProductSelection }>()
);

export const goToExistingCustomerLeadForm = createAction(
  `${PREFIX} go to existing customer lead form`,
  props<{ url: string }>()
);
